import React from 'react';

const ReporterDashboard = () => (
  <h2>Welcome to Reporter Dashboard</h2>
);

export default ReporterDashboard;
